import React, { Component } from 'react';
import ReactDataGrid from 'react-data-grid';
import { Data } from 'react-data-grid-addons';
import { withRouter } from 'react-router';
import { Grid, Row, Col, Panel, ButtonToolbar, Button, Breadcrumb } from 'react-bootstrap';
import { SkyLightStateless } from 'react-skylight';
import { Translate } from 'react-redux-i18n';

import ContentWrapper from '../../components/Layout/ContentWrapper';
import { UI_HEIGHT } from '../Common/constants';
import Spinner from '../../components/Widgets/spinner';
import { ROOT_URL } from '../../actions/root_url';
import EditPosPaymentModal from '../../containers/Sales/EditPosPaymentModal';

class ViewPosOrder extends Component {
    static contextTypes = {
      router: React.PropTypes.object
    };

    constructor() {
      super();
      this.state = {
        tableHeight: window.innerHeight - UI_HEIGHT.editSalesInvPage,
        totalPrice: 0,
        totalTax: 0,
        finalPrice: 0,
        totalCRV: 0,

        paymentInfo: {
          cardAmount: 0,
          cardNum: '',
          cashAmount: 0,
          change: 0,
          checkAmount: 0,
          checkNum: '',
          creditAmount: 0,
          mobileAmount: 0,
        },

        posOrder: {
          rows: [],
          filters: {},
          sortColumn: null,
          sortDirection: null
        },
        currentOrder: null,
        showEditPaymentOpen: false,
      }
    }

  componentDidMount() {
      window.addEventListener('resize', this.handleResize);
      if (this.props.params && this.props.params.id) {
          this.props.fetchPosOrderDetail(this.props.params.id);
          this.setState({ currentOrder: this.props.params.id });
      } else {
        this.context.router.push('/posOrders/');
      }
    }

    componentWillUnmount() {
      window.removeEventListener('resize', this.handleResize);
    }

    componentWillReceiveProps(nextProps) {
      if (nextProps.posOrderDetail && nextProps.posOrderDetail != this.props.posOrderDetail) {
        let posOrder = {...this.state.posOrder, rows: nextProps.posOrderDetail.POS_Order_Lines}
        let totalPrice = nextProps.posOrderDetail.Subtotal || 0;
        let totalTax = nextProps.posOrderDetail.SalesTax || 0;
        let finalPrice = nextProps.posOrderDetail.FinalPrice || 0;
        let totalCRV = nextProps.posOrderDetail.CRV || 0;

        totalPrice = roundTo(totalPrice, 2).toFixed(2);
        finalPrice = roundTo(finalPrice, 2).toFixed(2);
        totalCRV = roundTo(totalCRV, 2).toFixed(2);
        totalTax = roundTo(totalTax, 2).toFixed(2);

        let {
          CashAmount: cashAmount,
          Change: change,
          CheckAmount: checkAmount,
          CreditCardAmount: cardAmount,
          StoreCreditAmount: creditAmount,
          MobileAmount: mobileAmount,
        } = nextProps.posOrderDetail;
        const {
          CheckNum: checkNum,
          CreditCardNumber: cardNum,
        } = nextProps.posOrderDetail;

        cashAmount = +roundTo(cashAmount, 2).toFixed(2);
        change = +roundTo(change, 2).toFixed(2);
        checkAmount = +roundTo(checkAmount, 2).toFixed(2);
        cardAmount = +roundTo(cardAmount, 2).toFixed(2);
        creditAmount = +roundTo(creditAmount, 2).toFixed(2);
        mobileAmount = +roundTo(mobileAmount, 2).toFixed(2);

        const paymentInfo = {
          cashAmount,
          change,
          checkAmount,
          cardAmount,
          checkNum,
          cardNum,
          creditAmount,
          mobileAmount,
        };
        this.setState({
          posOrder,
          totalPrice,
          totalTax,
          finalPrice,
          totalCRV,
          paymentInfo,
        });
      }
    }

    openShowEditPayment = () => {
      this.setState({ showEditPaymentOpen: true });
    }

    closeShowEditPayment = () => {
      this.setState({ showEditPaymentOpen: false });
    }

    breadcrumbs() {
      return <Breadcrumb>
        <Breadcrumb.Item>
          <Translate value="pos_management" />
        </Breadcrumb.Item>
        <Breadcrumb.Item>
          <Translate value="pos_order" />
        </Breadcrumb.Item>
        <Breadcrumb.Item active="true">
          <Translate value="view_pos_order" />
        </Breadcrumb.Item>
      </Breadcrumb>
    }

  renderPosOrder() {
    let that = this;
      if (this.props.detailIsLoading && !this.props.detailError) return <Spinner/>
      else if (this.props.detailError) return <ContentWrapper><div className="alert alert-danger">{JSON.stringify(this.props.detailError)}</div></ContentWrapper>
      else {
          // Parameters of the react-data-grid
          const getRows = () => {
              return Data.Selectors.getRows(this.state.posOrder);
          }

          const getSize = () => {
              return getRows().length;
          }

          const rowGetter = rowIdx => {
              var rows = getRows();
              return rows[rowIdx];
          }

          // Handle the sortable function

          const handleGridSort = (sortColumn, sortDirection) => {
              var posOrder = {...this.state.posOrder, sortColumn, sortDirection };
              this.setState({posOrder});
          }

          const IsVariableFormatter = React.createClass({
              render() {
                if (this.props.dependentValues.ProductType !== "Non-Fixed") {
                  return <span>{this.props.value} </span>
                } else {
                  return <span>{this.props.value} <label className="label label-success"><Translate value="non_fixed" /></label></span>;
                }
              }
          });

          // Column difinition

          const columns = [
              {
                  key: 'ProductNum',
                  name: <Translate value="product_num" />,
                  resizable: true,
                  sortable: true,
                  width: 100,
              },
              {
                  key: 'RefNum',
                  name: <Translate value="ref_num" />,
                  resizable: true,
                  sortable: true,
                  width: 70,
              },
              {
                  key: 'Name',
                  name: <Translate value="product_name" />,
                  resizable: true,
                  sortable: true,
              },
              {
                  key: 'Description',
                  name: <Translate value="description" />,
                  resizable: true,
                  sortable: true,
              },
              {
                  key: 'Quantity',
                  name: <Translate value="qty" />,
                  resizable: true,
                  width: 40,
                  sortable: true,
                  formatter: IsVariableFormatter,
                  getRowMetaData: (row) => row
              },
              {
                  key: 'PackageType',
                  name: <Translate value="pkg_type" />,
                  resizable: true,
                  width: 80,
                  sortable: true,
              },
              {
                  key: 'TotalNetWeight',
                  name: <Translate value="total_wt" />,
                  resizable: true,
                  width: 100,
                  sortable: true,
              },
              {
                  key: 'UnitPrice',
                  name: <Translate value="unit_dollarsign" />,
                  resizable: true,
                  width: 70,
                  sortable: true,
              },
              {
                  key: 'TotalPrice',
                  name: <Translate value="total_dollarsign" />,
                  resizable: true,
                  width: 80,
                  sortable: true,
              }
          ]

          return (
              <Row>
                <Col xs={ 12 }>
                  <div id="ViewPosOrder-dataGrid1">
                    <ReactDataGrid
                      rowKey='Product_id'
                      onGridSort={handleGridSort}
                      columns={columns}
                      rowHeight={25}
                      headerRowHeight={45}
                      rowGetter={rowGetter}
                      rowsCount={getSize() }
                      minHeight={this.state.tableHeight}
                      />
                  </div>
                </Col>
              </Row>
          )
      }
  }

    render() {
      const totalPrice = (<h2><Translate value="total_dollarsign" /></h2>);
      const tax = (<h2><Translate value="tax" /></h2>);
      const crv = (<h2><Translate value="crv" /></h2>);
      const finalPriceHeader = (<h2><Translate value="final_dollarsign" /></h2>);

      const createDialogEditPaymentStyle = {
        width: '550px',
        height: '550px',
        marginLeft: '-15%',
      };

      const { currentOrder: posOrderID, paymentInfo, finalPrice } = this.state;
      let printUrl = ROOT_URL + 'v1/pos/orders/print/' + posOrderID + '?Bearer=' + localStorage.getItem('token');
      let excelUrl = ROOT_URL + 'v1/pos/orders/excel/' + posOrderID + '?Bearer=' + localStorage.getItem('token');
      if (this.props.detailIsLoading && !this.props.detailError) return <ContentWrapper><br/>...<Translate value="reading_data" /></ContentWrapper>
      else if (this.props.detailError) return <ContentWrapper><div className="alert alert-danger">{this.props.error}</div></ContentWrapper>
      else {
        const { posOrderDetail } = this.props;
        const posNumTitle = (posOrderDetail && posOrderDetail.Order_Num) || '';
        return (
          //---------------
          // Begin HTML
          //---------------
          <ContentWrapper>
            {/* Nav Trail */}
            {this.breadcrumbs()}
            <ButtonToolbar>
              <Button
                bsStyle='warning'
                type='button'
                onClick={this.openShowEditPayment}
              >
                <Translate value="edit_payment_method" />
              </Button>
              <Button
                bsStyle='primary'
                type='button'
                href={printUrl} >
                <em className='fa fa-print' /><Translate value="print" />
              </Button>
              <Button
                bsStyle='success'
                type='button'
                href={excelUrl} >
                <em className='fa fa-download' /><Translate value="excel" />
              </Button>
              <Button
                bsStyle="danger"
                type="reset"
                onClick={() => { this.context.router.push('/posOrders')}} >
                {/* <Glyphicon glyph="close"/> */}
                <em className="fa fa-close" /><Translate value="cancel" />
              </Button>
            </ButtonToolbar>

            <Grid fluid="true" id="edit-sales-invoice">
              <h1>{ posNumTitle }</h1>
              <Row className="row-wrapper">
                <Col xs={ 10 } className="mb0">
                  <Panel>
                    {this.renderPosOrder()}
                  </Panel>
                </Col>

                <Col xs={ 2 } className="position-absolute">
                  <Panel header={totalPrice}>
                    <div className="form-control-static">
                      <span className="dollar-sign">$</span>{this.state.totalPrice}
                    </div>
                  </Panel>
                  <Panel header={tax}>
                    <div className="form-control-static">
                      <span className="dollar-sign">$</span>{this.state.totalTax}
                    </div>
                  </Panel>
                  <Panel header={crv}>
                    <div className="form-control-static">
                      <span className="dollar-sign">$</span>{this.state.totalCRV}
                    </div>
                  </Panel>
                  <Panel header={finalPriceHeader}>
                    <div className="form-control-static">
                      <span className="dollar-sign">$</span>{this.state.finalPrice}
                    </div>
                  </Panel>
                </Col>
              </Row>
            </Grid>
            <SkyLightStateless
              dialogStyles={createDialogEditPaymentStyle}
              isVisible={this.state.showEditPaymentOpen}
              onCloseClicked={this.closeShowEditPayment}
              title="edit payment info"
            >
              <EditPosPaymentModal
                posID={posOrderID}
                paymentInfo={{
                  ...paymentInfo,
                  finalPrice,
                }}
                onCloseClicked={this.closeShowEditPayment}
              />
            </SkyLightStateless>
          </ContentWrapper>
          //---------------
          // End HTML
          //---------------

        )
      }
    }
}

export default withRouter(ViewPosOrder);

function roundTo(n, digits) {
 if (digits === undefined) {
   digits = 0;
 }

 var multiplicator = Math.pow(10, digits);
 n = parseFloat((n * multiplicator).toFixed(11));
 var test =(Math.round(n) / multiplicator);
 return +(test.toFixed(2));
}



// WEBPACK FOOTER //
// ./master/jsx/components/Sales/viewPosOrder.jsx